import dbRefs from '../dbRefs'

const state = {
  query_location: '',
  queried_locations: []
}

const getters = {
  query_location: state => state.query_location,
  queried_locations: state => state.queried_locations
}

const mutations = {
  async query_location (state2, payload) {
    // console.log(`query_location: `, {_q: state.query_location})
    //
    dbRefs.state.firestore
      .collection("addressIndex")
      //.where("showToUser", "==", true) // if show only selected.
      //.orderBy("date")
      //.limit(100) // change limit
      .onSnapshot(function(db_locations) {
        // console.log("Current data: ", db_locations);
        let show_locations = []
        db_locations.forEach((loc)=>{
          if(loc.id.toLowerCase().includes(state.query_location.toLowerCase())) {
            let re = /\d/
            let hasNo = re.test(loc.id.toLowerCase())
            // console.log({ hasNo, loc2: loc.id.toLowerCase(), loc3: loc.data() })
            if (!hasNo && loc.data().pic_cnt) {
              if (loc.data().pic_cnt > 0) {
                let tmp = {
                  name: loc.id,
                  bold: loc.id.toLowerCase() === state.query_location.toLowerCase(),
                  pic_cnt: loc.data().pic_cnt
                }
                show_locations.push(tmp)
              }
            }
          }
        })
        state.queried_locations = show_locations
      })
    //
  }
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/filter/search_loc.js